import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';

// 导入语言文件
import messages from './langs';
import 'element-ui/lib/theme-chalk/index.css';
import { Message } from 'element-ui';
// main.js
import { highlightWords } from '@/utils/highlightWords';
// 导入通知窗口组件
import NoticeMark from '@/components/noticeMark.vue';

Vue.prototype.$highlight = function (text) {
  const words = this.$store.state.user.sensitiveWords;
  // console.log(highlightWords(text, words),'words')
  // console.log(text,words,'text')
  if (text) {
    return highlightWords(text, words);
  } else {
    return '';
  }
};

import 'reset-css'; //重置样式
import '@/style.scss';
import '@/common.scss';

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.use(VueI18n);

// 全局注册通知窗口组件
Vue.component('NoticeMark', NoticeMark);

const i18n = new VueI18n({
  locale: 'zh', // 设置默认语言环境为中文
  messages, // 设置加载的语言信息
});

// 挂载 Message 到 Vue 原型
Vue.prototype.$message = Message;

// 添加全局通知方法
Vue.prototype.$showNotice = function (options) {
  this.$store.dispatch('notice/showUpdateNotice', options);
};

Vue.prototype.$showUpdateNotice = function (options) {
  this.$store.dispatch('notice/showUpdateNotice', options);
};

Vue.prototype.$showMaintenanceNotice = function (options) {
  this.$store.dispatch('notice/showMaintenanceNotice', options);
};

Vue.prototype.$hideNotice = function () {
  this.$store.dispatch('notice/hideNotice');
};

// 添加全局播放礼物音效方法
Vue.prototype.$playGiftAudio = function () {
  const giftAudio = document.getElementById('giftAudio');
  if (!giftAudio) {
    console.log('音频元素未找到');
    return;
  }

  if (this.$store.state.sound.muted) {
    console.log('静音中，不播放礼物音效');
    return;
  }

  // 尝试播放音频
  giftAudio.play().catch((error) => {
    console.log('播放失败，可能是浏览器自动播放限制:', error);
  });
};

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
